import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import initialState from 'reducers/initialState';
import { emptyArray } from 'constants/emptyConst';

const productSelectionReducer = (state = initialState.currentOffer.productSelectionData, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PRODUCT_SELECTION_DATA_STARTED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          productDataLoaded: false,
          productDataLoading: true,
          computingSimulations: false,
          maxResidualValuePercentLoading: false
        }
      };
    }
    case actionTypes.LOAD_PRODUCT_SELECTION_DATA_SUCCESS: {
      return {
        ...state,
        filterDefinition: { ...action.payload.productSelectionData.filterDefinition },
        flags: {
          ...state.flags,
          productDataLoaded: true,
          productDataLoading: false,
          generateSimulationsButtonDisabled: action.payload.productSelectionData.simulationsGenerated,
          simulationsGenerationInProgress: action.payload.productSelectionData.simulationsGenerationInProgress,
        },
        contractTypes: [...action.payload.productSelectionData.contractTypes],
        showFilterOfferContracts: action.payload.productSelectionData.showFilterOfferContracts,
        products: [...action.payload.productSelectionData.simulationList],
        maximumNumberOfProducts: action.payload.productSelectionData.maximumNumberOfSimulations,
        simulationsGenerated: action.payload.productSelectionData.simulationsGenerated,
        exportSimulationButtonVisible: action.payload.productSelectionData.exportSimulationButtonVisible
      };
    }
    case actionTypes.LOAD_PRODUCT_SELECTION_DATA_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          productDataLoaded: false,
          productDataLoading: false
        }
      };
    }
    case actionTypes.COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_STARTED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          maxResidualValuePercentLoading: true
        }
      };
    }
    case actionTypes.COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_SUCCEEDED: {
      return {
        ...state,
        maxRezidualValueComputed: action.payload.maxResidualValuePercent,
        rezidualValueComputed: action.payload.residualValuePercent,
        flags: {
          ...state.flags,
          maxResidualValuePercentLoading: false
        }
      };
    }
    case actionTypes.COMPUTE_OFFER_PRODUCTS_MAX_RESIDUAL_VALUE_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          maxResidualValuePercentLoading: false
        }
      };
    }

    case actionTypes.FAVORITE_PRODUCT_SUCCEEDED: {
      let selectedSimulationIndex = state.products.findIndex(x => x.simulationDocumentId === action.payload.simulationDocumentId);
      return {
        ...state,
        products: Object.assign([...state.products], {
          [selectedSimulationIndex]: {
            ...state.products[selectedSimulationIndex],
            priority: action.payload.priority
          }
        })
      };
    }

    case actionTypes.DELETE_PRODUCT_SUCCEEDED: {
      let selectedSimulationIndex = state.products.findIndex(x => x.simulationDocumentId === action.payload.simulationDocumentId);
      let newProducts = Object.assign([], [...state.products]);
      newProducts = newProducts.filter((_, idx) => {
        return idx !== selectedSimulationIndex;
      });
      return {
        ...state,
        products: newProducts
      };
    }

    case eventTypes.FINANCIAL_PRODUCT_LIST_COMPUTED: {
      const newProducts = action.event.eventBody.products.map(product => ({ ...product, computingStatus: 0, isValidated: false }));
      return {
        ...state,
        products: [...(newProducts || emptyArray)]
      };
    }

    case eventTypes.SIMULATION_BASIC_COMPUTED: {
      const newProducts = state.products.map(product =>
        product.productId === action.event.eventBody.productId ? { ...product, ...action.event.eventBody, computingStatus: 50, isValidated: false } : product
      );
      return {
        ...state,
        products: [...(newProducts || emptyArray)]
      };
    }

    case eventTypes.SIMULATION_COMPUTED: {
      const newProducts = state.products.map(product =>
        product.productId === action.event.eventBody.productId ? { ...product, ...action.event.eventBody, computingStatus: 75, isValidated: false } : product
      );
      return {
        ...state,
        products: [...(newProducts || emptyArray)]
      };
    } 
    case eventTypes.SIMULATION_VALIDATED: {
      const newProducts = state.products.map(product =>
        product.simulationDocumentId === action.event.eventBody.simulationId ? { ...product, ...action.event.eventBody, computingStatus: 100, isValidated: true } : product
      );
      return {
        ...state,
        products: [...(newProducts || emptyArray)]
      };
    }

    case actionTypes.SIMULATIONS_FILTERS_MODIFIED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          generateSimulationsButtonDisabled: false
        }
      };
    }

    case actionTypes.SIMULATIONS_RECOMPUTE_STARTED: {
      const newProducts = state.products.map(product => ({
        productId: product.productId,
        leasingTypeName: product.leasingTypeName,
        creditCurrencyCode: product.creditCurrencyCode,
        computingStatus: 0,
        isValidated: false
      }));
      return {
        ...state,
        flags: {
          ...state.flags,
          computingSimulations: true
        },
        products: [...(newProducts || emptyArray)]
      };
    }

    case actionTypes.SIMULATIONS_RECOMPUTE_SUCCEEDED: {
      let filters = { ...state.filterDefinition };
      let contractTypesUpdated = [...state.contractTypes];
      if (action.payload.recomputeSimulationsCompleted.filters) {
        filters = {
          ...state.filterDefinition,
          financingPeriod: {
            ...state.filterDefinition.financingPeriod,
            value: action.payload.recomputeSimulationsCompleted.filters.financingPeriod.value,
            minValue: action.payload.recomputeSimulationsCompleted.filters.financingPeriod.minValue,
            maxValue: action.payload.recomputeSimulationsCompleted.filters.financingPeriod.maxValue
          },
          advancePercent: {
            ...state.filterDefinition.advancePercent,
            value: action.payload.recomputeSimulationsCompleted.filters.advancePercent.value,
            minValue: action.payload.recomputeSimulationsCompleted.filters.advancePercent.minValue,
            maxValue: action.payload.recomputeSimulationsCompleted.filters.advancePercent.maxValue
          },
          residualValuePercent: {
            ...state.filterDefinition.residualValuePercent,
            value: action.payload.recomputeSimulationsCompleted.filters.residualValuePercent.value,
            minValue: action.payload.recomputeSimulationsCompleted.filters.residualValuePercent.minValue,
            maxValue: action.payload.recomputeSimulationsCompleted.filters.residualValuePercent.maxValue
          },
          agreedMileage: action.payload.recomputeSimulationsCompleted.filters.agreedMileage
        };
      }

      if (action.payload.recomputeSimulationsCompleted.contractTypeIds) {
        contractTypesUpdated.forEach(ct => {
          ct.isSelected = false;
          if (action.payload.recomputeSimulationsCompleted.contractTypeIds.includes(ct.contractTypeId)) {
            ct.isSelected = true;
          }
        });
      }
      const shouldReloadTheSimulations = state.flags.simulationsGenerationInProgress;
      
      return {
        ...state,
        flags: {
          ...state.flags,
          computingSimulations: false,
          generateSimulationsButtonDisabled: action.payload.recomputeSimulationsCompleted.simulationsGenerated,
          simulationsGenerationInProgress: false,
          productDataLoaded:shouldReloadTheSimulations ? false : state.flags.productDataLoaded,
          productDataLoading: shouldReloadTheSimulations ? true : state.flags.productDataLoading
        },
        contractTypes: contractTypesUpdated,
        filterDefinition: filters
      };
    }
    case actionTypes.SIMULATIONS_RECOMPUTE_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          computingSimulations: false
        }
      };
    }

    case actionTypes.SIMULATIONS_SELECTION_STARTED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          selectingProductId: action.payload.productId
        }
      };
    }

    case actionTypes.SIMULATIONS_SELECTION_FAILED: {
      return {
        ...state,
        flags: {
          ...state.flags,
          selectingProductId: null
        }
      };
    }

    case eventTypes.SIMULATION_MESSAGES_PROCESSED: {
      const newProducts = state.products.map(product =>
        product.simulationDocumentId === action.event.eventBody.simulationDocumentId
          ? { ...product, leasingSimulationMessages: action.event.eventBody.leasingSimulationMessages }
          : product
      );
      return {
        ...state,
        products: [...(newProducts || emptyArray)]
      };
    }

    case actionTypes.SIMULATIONS_SELECTION_SUCCEEDED: {
      const newProducts = state.products.map(product => ({
        ...product,
        selected: product.productId === action.payload.productId
      }));
      return {
        ...state,
        flags: {
          ...state.flags,
          selectingProductId: null
        },
        products: [...(newProducts || emptyArray)]
      };
    }

    case actionTypes.SET_FINANCIAL_PRODUCTS_VIEW_MODE: {
      return {
        ...state,
        flags: {
          ...state.flags,
          viewMode: action.value
        }
      };
    }

    case eventTypes.OFFER_FINANCIAL_PRODUCT_INVALIDATED: {
      return initialState.currentOffer.productSelectionData;
    }

    default:
      return state;
  }
};

export default productSelectionReducer;
